// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IBlockCubeColumn {
  height: number;
  contiguousHeight: number;
  opaqueHeight: number;
}
